import { render, staticRenderFns } from "./UiIconify.vue?vue&type=template&id=07c59443&"
import script from "./UiIconify.vue?vue&type=script&lang=js&"
export * from "./UiIconify.vue?vue&type=script&lang=js&"
import style0 from "./UiIconify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports